export default defineNuxtPlugin({
  name: 'error',
  async setup() {
    const { hook } = useNuxtApp();
    hook('app:error', error => {
      console.error(error);
    });
  },
});
